import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const BackButton = ({ testId = "back-button", fallback = "/", className = "" }) => {
  const nav = useNavigate();
  const goBack = () => (window.history.state?.idx > 0 ? nav(-1) : nav(fallback));
  return (
    <button
      type="button"
      onClick={goBack}
      data-testid={testId}
      className={`${className} inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-primary`}
    >
      <ArrowLeft size={14} /> Back
    </button>
  );
};
